<template>
   <button type="button" class="btn">{{ name }}</button>
</template>

<script>
export default {
    props: ['name']
}
</script>